import { createReducer } from 'typesafe-actions';

import { Auth2FaActionTypes, T2FaAction } from '../types/auth2Fa.types';

import { IAuthState } from '@/store/types/auth.types';

const initialState: IAuthState = {};

export const auth2FaReducer = createReducer<IAuthState, T2FaAction>(initialState)
  .handleType(Auth2FaActionTypes.CREATE_PASSKEY, (state) => ({ ...state, isLoading: true, error: undefined }))
  .handleType(Auth2FaActionTypes.CREATE_PASSKEY_SUCCESS, (state, action) => ({
    ...state,
    currentSupportUser: {
      ...state.currentSupportUser,
      state: {
        ...state.currentSupportUser.state,
        secureKey: { ...action.passkey },
      },
    },
    isLoading: false,
  }))
  .handleType(Auth2FaActionTypes.CREATE_PASSKEY_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))
  .handleType(Auth2FaActionTypes.GET_PASSKEY, (state) => ({ ...state, isLoading: true, error: undefined }))
  .handleType(Auth2FaActionTypes.GET_PASSKEY_SUCCESS, (state, action) => ({
    ...state,
    currentSupportUser: {
      ...state.currentSupportUser,
      state: {
        ...state.currentSupportUser.state,
        secureKey: { ...action.passkey },
      },
    },
    isLoading: false,
  }))
  .handleType(Auth2FaActionTypes.GET_PASSKEY_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))
  .handleType(Auth2FaActionTypes.AUTHENTICATE, (state) => ({ ...state, isLoading: true, error: undefined }))
  .handleType(Auth2FaActionTypes.AUTHENTICATE_SUCCESS, (state, action) => ({
    ...state,
    token: action.token,
    auth2Fa: {
      credentials: action.credentials,
    },
    isLoading: false,
  }))
  .handleType(Auth2FaActionTypes.AUTHENTICATE_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))
  .handleType(Auth2FaActionTypes.GENERATE_CHALLENGE, (state) => ({ ...state, isLoading: true, error: undefined }))
  .handleType(Auth2FaActionTypes.GENERATE_CHALLENGE_SUCCESS, (state) => ({
    ...state,
    isLoading: false,
  }))
  .handleType(Auth2FaActionTypes.GENERATE_CHALLENGE_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }));
